import React, { useState, useEffect, useMemo } from 'react';
import Grid from '@material-ui/core/Grid';
import { FormHelperText, InputLabel, Typography } from '@material-ui/core';
import { Table, TableBody, TableHead, Divider } from '@material-ui/core';
import { useToast } from '../../../../../../Core/Hooks/useToast';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import { SingleSelect, SimpleField, SecondaryCheckbox } from '../../../../../../Core/Controls';
import { StyledTableCell, StyledTableRow } from '../../../../../../Core/Controls/Table/StyledCell&Row';
import { some } from 'lodash';

import { useWindowSize } from '../../../../../../Core/Hooks/useWindowSize';

function SalesLines(props) {
    const {
        invoiceLinesCheckBox,
        invoiceLinesCheckField,
        PartSelectChange,
        handleFields,
        invoiceLines,
        partsDetails,
        vatRate,
        invoiceItemVATRateID,
        onInvoiceItemChange
    } = props;
    const [width, height] = useWindowSize();

    let checkSize = width <= 1760 ? 2 : 1;

    return (
        <div>
            <TableContainer
                component={Paper}
                style={{
                    overflow: 'hidden'
                }}
            >
                <Table style={{ height: '100%' }}>
                    <TableBody>
                        {invoiceLines.map((m, i) => {
                            let temp = 0;
                            return (
                                <React.Fragment>
                                    <StyledTableRow>
                                        <StyledTableCell colSpan={i == 0 ? 6 : 7}>
                                            <Typography variant="h6" color="secondary">
                                                Labour
                                            </Typography>
                                        </StyledTableCell>
                                        {i == 0 && (
                                            <StyledTableCell>
                                                <FormHelperText shrink>VAT Rate</FormHelperText>
                                                <SingleSelect value={invoiceItemVATRateID} onChange={onInvoiceItemChange} options={vatRate} />
                                            </StyledTableCell>
                                        )}
                                        <StyledTableCell>&nbsp;</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell width="5%">
                                            <SecondaryCheckbox
                                                checked={m.isSelected}
                                                name="isSelected"
                                                label={m.isSelected}
                                                onChange={invoiceLinesCheckBox(m.itemID)}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell align="left" width="25%">
                                            <FormHelperText shrink>Labour Description</FormHelperText>
                                            <Typography variant="subtitle2">
                                                {m.labourDescription || 'N/A'}
                                                <br /> Cost Type: {m.costType || 'N/A'}
                                            </Typography>
                                        </StyledTableCell>
                                        <StyledTableCell width="10%">
                                            <SimpleField
                                                inputLabel="Hours"
                                                name="labourHours"
                                                placeholder="Hours"
                                                onChange={invoiceLinesCheckField(null, m.itemID)}
                                                value={m.labourHours}
                                                type="number"
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell width="10%">
                                            <SimpleField
                                                inputLabel="Labour Rate"
                                                name="labourRate"
                                                placeholder="Labour Rate"
                                                onChange={invoiceLinesCheckField(null, m.itemID)}
                                                value={m.labourRate}
                                                type="number"
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell width="10%">
                                            <SimpleField
                                                inputLabel="Discount %"
                                                name="labourDiscount"
                                                placeholder="Discount %"
                                                onChange={invoiceLinesCheckField(null, m.itemID)}
                                                value={m.labourDiscount}
                                                type="number"
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell width="10%">
                                            <SimpleField
                                                inputLabel="Ex VAT Total"
                                                name="labourExVAT"
                                                placeholder="Ex VAT Total"
                                                onChange={invoiceLinesCheckField(null, m.itemID)}
                                                value={m.labourExVAT}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell width="15%">
                                            <FormHelperText shrink>VAT Rate</FormHelperText>
                                            <SingleSelect
                                                value={m.invoiceItemVATRateID}
                                                onChange={invoiceLinesCheckField(m.labourExVAT, m.itemID)}
                                                options={vatRate}
                                            />
                                            <FormHelperText error>{m.vatIdError ? 'This Field is Required' : null}</FormHelperText>
                                        </StyledTableCell>
                                        <StyledTableCell width="15%">
                                            <SimpleField
                                                inputLabel="VAT Amount"
                                                name="invoiceItemVAT"
                                                placeholder="VAT"
                                                onChange={invoiceLinesCheckField(null, m.itemID)}
                                                value={m.invoiceItemVAT}
                                            />
                                        </StyledTableCell>
                                    </StyledTableRow>
                                    {some(partsDetails, (r) => r.jobItemID == m.itemID) && (
                                        <React.Fragment>
                                            <StyledTableRow>
                                                <StyledTableCell colSpan={1}>&nbsp;</StyledTableCell>
                                                <StyledTableCell colSpan={7}>
                                                    <Typography variant="h6" color="secondary">
                                                        Parts
                                                    </Typography>
                                                </StyledTableCell>
                                            </StyledTableRow>
                                            {partsDetails.map((p, k) => {
                                                if (p.jobItemID == m.itemID) {
                                                    temp++;
                                                    return (
                                                        <StyledTableRow>
                                                            <StyledTableCell width="5%">&nbsp;</StyledTableCell>
                                                            <StyledTableCell width="25%">
                                                                <Grid container spacing={1}>
                                                                    <Grid item xs={3} md={2} lg={1}>
                                                                        <InputLabel>{'\u{2800}'}</InputLabel>
                                                                        <SecondaryCheckbox
                                                                            checked={p.isSelected}
                                                                            name="isSelected"
                                                                            onChange={handleFields(p.partID)}
                                                                            label={p.name}
                                                                            style={{ marginTop: temp != 1 ? -23 : 0 }}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={9} md={10} lg={11}>
                                                                        {temp == 1 && <FormHelperText shrink>Part Number </FormHelperText>}
                                                                        <Typography variant="subtitle2">
                                                                            {p.partNumber || 'N/A'}
                                                                            <br /> Description:{p.partDescription || 'N/A'}
                                                                        </Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            </StyledTableCell>
                                                            <StyledTableCell width="10%">
                                                                <SimpleField
                                                                    inputLabel={temp == 1 ? 'Quantity' : null}
                                                                    name="qty"
                                                                    placeholder="Quantity"
                                                                    onChange={handleFields(p.partID)}
                                                                    value={p.qty}
                                                                    type="number"
                                                                />
                                                            </StyledTableCell>
                                                            <StyledTableCell width="10%">
                                                                <SimpleField
                                                                    inputLabel={temp == 1 ? 'Unit Price' : null}
                                                                    name="unitPrice"
                                                                    placeholder="Unit Price"
                                                                    onChange={handleFields(p.partID)}
                                                                    value={p.unitPrice}
                                                                    type="number"
                                                                />
                                                            </StyledTableCell>
                                                            <StyledTableCell width="10%">
                                                                <SimpleField
                                                                    inputLabel={temp == 1 ? 'Discount %' : null}
                                                                    name="discount"
                                                                    placeholder="Discount %"
                                                                    onChange={handleFields(p.partID)}
                                                                    value={p.discount}
                                                                    type="number"
                                                                />
                                                            </StyledTableCell>
                                                            <StyledTableCell width="10%">
                                                                <SimpleField
                                                                    inputLabel={temp == 1 ? 'Ex VAT Total' : null}
                                                                    name="total"
                                                                    placeholder="Ex VAT Total"
                                                                    onChange={handleFields(p.partID)}
                                                                    value={p.total}
                                                                />
                                                            </StyledTableCell>
                                                            <StyledTableCell width="15%">
                                                                {temp == 1 && <FormHelperText shrink>VAT Rate</FormHelperText>}
                                                                <SingleSelect
                                                                    value={p.invoiceItemVATRateID}
                                                                    onChange={PartSelectChange(p.total, p.partID)}
                                                                    options={vatRate}
                                                                />
                                                                <FormHelperText error>{p.vatIdError ? 'This Field is Required' : null}</FormHelperText>
                                                            </StyledTableCell>
                                                            <StyledTableCell width="15%">
                                                                <SimpleField
                                                                    inputLabel={temp == 1 ? 'VAT Amount' : null}
                                                                    name="invoiceItemVAT"
                                                                    placeholder="VAT"
                                                                    onChange={handleFields(p.partID)}
                                                                    value={p.invoiceItemVAT}
                                                                />
                                                            </StyledTableCell>
                                                        </StyledTableRow>
                                                    );
                                                }
                                            })}
                                        </React.Fragment>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}
export default SalesLines;
